import { render, staticRenderFns } from "./StatVisitors.vue?vue&type=template&id=33beeac6&scoped=true&"
import script from "./StatVisitors.vue?vue&type=script&lang=ts&"
export * from "./StatVisitors.vue?vue&type=script&lang=ts&"
import style0 from "./StatVisitors.vue?vue&type=style&index=0&id=33beeac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33beeac6",
  null
  
)

component.options.__file = "StatVisitors.vue"
export default component.exports